import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Plus } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
export const BoardSelectListHeader = (param)=>{
    let { children, onCreate } = param;
    return /*#__PURE__*/ _jsxs("h2", {
        className: "flex h-6 shrink-0 items-center justify-between gap-2 px-2 text-12 font-bold uppercase tracking-wider text-grey-9",
        children: [
            children,
            !!onCreate && /*#__PURE__*/ _jsx(IconButton, {
                appearance: "ghost",
                color: "grey",
                icon: Plus,
                label: "Create new",
                onClick: onCreate,
                size: "small"
            })
        ]
    });
};
